import './UpdateRequests.css';
import { useState, useEffect, useContext } from 'react';
import {Context} from '../Context';
import moment from 'moment';
import newUpdateRequestService from '../Services/UpdateRequestService';

import { FaFlag,FaSearch,FaArrowUp,FaArrowDown } from "react-icons/fa";
import { BsPersonFillAdd,BsPersonFillUp  } from "react-icons/bs";
import { RotatingLines } from "react-loader-spinner";


const Loader = () => {
  return (
    <RotatingLines
      strokeColor="rgb(6, 89, 79)"
      strokeWidth="5"
      animationDuration="0.75"
      width="96"
      visible={true}
    />
  )
};

const organizeDate = (date) => {
    return moment(date).format("MMM Do YYYY");
};

const SearchBar = ({setSearchInput,searchList, selectSearchItem}) => {
    const [ focused, setFocused ] = useState(false);

    const handleSearchItemClick = (businessName) => {
        selectSearchItem(businessName);
        setFocused(false);
        document.getElementById('myInput').value = ''
        setSearchInput('');
    };

    return(      
        <div className='Update-Request-Header-Search' onClick={() => setFocused(true)}  onMouseLeave={() => setFocused(false)}>
            <FaSearch  className='Update-Request-Header-Search-Icon'/>
            <input autoComplete="off"  onChange={((e) => setSearchInput(e.target.value))} id="myInput" className='Update-Request-Header-Search-Text' placeholder='Search Update Requests'/>

            {   focused && searchList && 
            <div className='Update-Request-Header-Search-List'>
            {   
                searchList.map((object, key) => (
                    <div key={key} className='Update-Request-Header-Search-Term' onClick={(event) => {handleSearchItemClick(object.business_name); event.stopPropagation()}}>
                        {object.business_name}
                    </div>
                ))
            }
            </div>
            }

        </div>
    )
};

const ActiveSelector = ({activeSort,setActiveSort}) => {
    return(
        <div className='Update-Request-Header-Active'>

            {   activeSort && activeSort !== 'both' &&
            <div className='Update-Request-Header-Select Selected-Active'>
                Active
            </div>
            }
            { activeSort === 'both' &&
            <div className='Update-Request-Header-Select ' onClick={() => setActiveSort(true)}>
                Active
            </div>
            }
            {   !activeSort &&
            <div className='Update-Request-Header-Select ' onClick={() => setActiveSort(true)}>
                Active
            </div>
            }


            <div className='Update-Request-Header-Select-Divider'/>

            {   !activeSort &&
            <div className='Update-Request-Header-Select Selected-Active'>
                InActive
            </div>
            }
            {   activeSort &&
            <div className='Update-Request-Header-Select' onClick={() => setActiveSort(false)}>
                InActive
            </div>  
            }

            <div className='Update-Request-Header-Select-Divider'/>

            {   activeSort === 'both' &&
            <div className='Update-Request-Header-Select Selected-Active'>
                Both
            </div>
            }
            {   activeSort !== 'both' &&
            <div className='Update-Request-Header-Select' onClick={() => setActiveSort('both')}>
                Both
            </div>  
            }
        </div>
    )
};

const ControlBar = ({resetList,activeSort,setActiveSort,setAddingRecord}) => {
    return(
        <div className='Update-Request-Header-Controls'>
            <ActiveSelector activeSort={activeSort} setActiveSort={setActiveSort}/>
            <button onClick={() => resetList()} className='Update-Request-Header-All-Button'>Default View</button>
            <button onClick={() => setAddingRecord(true)} className='Update-Request-Header-All-Button'>New Update Request</button>
        </div>
    )
};

const SortDirectionIndicator = ({currentSelection, validSelection, direction}) => {
    if(currentSelection === validSelection){
        if(direction === 'ASC') return <FaArrowUp />
        else return <FaArrowDown />
    }

};

const BottomHeader = ({screenWidth, sortDirection, orderBy, handleOrderClick}) => {
    return(
        <div className='Update-Request-Bottom-Header'>

            <div className='Update-Request-Tile-Information'>
                <div className='Update-Request-Tile-Data Header-Title' onClick={() => handleOrderClick('update_type')}>
                    Request Type <SortDirectionIndicator currentSelection={orderBy} validSelection={'update_type'} direction={sortDirection}/>
                </div>
                <div className='Update-Request-Tile-Data Header-Title' onClick={() => handleOrderClick('business_name')}>
                    Business Name <SortDirectionIndicator currentSelection={orderBy} validSelection={'business_name'} direction={sortDirection}/>
                </div>
                <div className='Update-Request-Date Header-Title' onClick={() => handleOrderClick('date')}>
                    Created Date <SortDirectionIndicator currentSelection={orderBy} validSelection={'date'} direction={sortDirection}/>
                </div>
            </div>

        </div>
    )
};

const UpdateRequestHeader = ({updateHeaderObject}) => {
    const {setSearchInput,sortDirection,flipSortOrder,screenWidth, orderBy, handleOrderClick, searchList, selectSearchItem,resetList, 
        activeSort, setActiveSort, setAddingRecord} = updateHeaderObject;
    return(
        <div className='Update-Request-Header'>
            <div className='Update-Request-Top-Header'>
                <SearchBar setSearchInput={setSearchInput} searchList={searchList} selectSearchItem={selectSearchItem}/>
                <ControlBar resetList={resetList} activeSort={activeSort} setActiveSort={setActiveSort} setAddingRecord={setAddingRecord}/>
            </div>
            <BottomHeader screenWidth={screenWidth} sortDirection={sortDirection} orderBy={orderBy} handleOrderClick={handleOrderClick} />

        </div>
    )
};

const TileHoverPanel = ({update,toggleFlag}) => {
    return (
        <div className='Update-Request-Flag-Frame'>
            {   update.flag &&
                <FaFlag className='Update-Request-Flag-Checked' onClick={(event) => {toggleFlag(update.id); event.stopPropagation()}}/>
            }
            {   !update.flag &&
                <FaFlag className='Update-Request-Flag-Unchecked' onClick={(event) => {toggleFlag(update.id); event.stopPropagation()}}/>
            }
            
        </div>
    )
};

const UpdateTile = ({update, toggleFlag, screenWidth,markUpdateInactive,markUpdateActive}) => {
    const [ hover, setHover ] = useState();

    return(
        <div className='Vender-Request-Tile' onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)}>

            <div className='Update-Request-Tile-Information'>
                <div className='Update-Request-Tile-Data'>
                    {`${update.form_type} Update Request`}
                </div>
                <div className='Update-Request-Tile-Data'>
                    {update.legal_name}
                </div>
                {   screenWidth > 1000 &&
                <div className='Update-Request-Tile-Data'>
                    {`${update.city}, ${update.state}`}
                </div>
                }

                <div className='Update-Request-Date'>
                    {organizeDate(update.date)}
                </div>
                {   screenWidth > 1000 &&
                <>
                {hover && <TileHoverPanel update={update} toggleFlag={toggleFlag}/>}
                {!hover &&
                    <div className='Update-Request-Flag-Frame'>
                        {   update.flag &&
                            <FaFlag className='Update-Request-Flag'/>
                        }
                    </div>
                }
                </>
                }
 
            </div>
            
        </div>
    )
};

const EmptyUpdateDisplay = () => {
    return(
        <div className='Update-Request-No-Display'>
            No Records to Display.
        </div>
    )
};

const UpdateRequestDisplay = ({updateRequestObject}) => {
    const { updateList, toggleFlag, screenWidth, markUpdateInactive, markUpdateActive } = updateRequestObject;    

    return(
        <div className='Update-Request-Display'> 
            {   updateList && updateList.length > 0 &&
                updateList.map((update, key) => (
                    <UpdateTile key={key} update={update} toggleFlag={toggleFlag} screenWidth={screenWidth} markUpdateInactive={markUpdateInactive} markUpdateActive={markUpdateActive} />
                ))
            }
            {   updateList.length < 1 &&
                <EmptyUpdateDisplay />
            }
        </div>
    )
};

const NewUpdateRequestRecord = ({newUpdateRequestObject}) => {
    const { setAddingRecord, updateType, setUpdateType, recordId, setRecordId, businessName, setBusinessName, text, setText, createUpdateRequest, resultsList } = newUpdateRequestObject;

    return(
        <div className='Update-Request-Record-Overlay' onClick={(event) => newUpdateRequestObject.setAddingRecord(false)}>
            <div className='Update-Request-Record-Container' onClick={(event) => event.stopPropagation()}>
                <h3>Create Update Request</h3>
                <div>
                    <label>Update Type:</label>
                    <input type="text" value={updateType} onChange={(e) => setUpdateType(e.target.value)} />
                </div>
                <div>
                    <label>Record ID:</label>
                    <input type="text" value={recordId} onChange={(e) => setRecordId(e.target.value)} />
                </div>
                <div>
                    <label>Business Name:</label>
                    <input type="text" value={businessName} onChange={(e) => setBusinessName(e.target.value)} />
                </div>
                <div>
                    <label>Text:</label>
                    <textarea value={text} onChange={(e) => setText(e.target.value)} />
                </div>
                <button onClick={() => createUpdateRequest()}>Create Update Request</button>
            </div>
        </div>
    )
};

const UpdateRequests = () => {
    const contextObject = useContext(Context);

    const [ addingRecord, setAddingRecord ] = useState(false);

    const [ orderBy, setOrderBy ] = useState('date');

    const [ sortDirection, setSortDirection ] = useState('ASC');
    const [ activeSort, setActiveSort ] = useState(true);

    const [ updateList, setUpdateList ] = useState([]);
    const [ updateRecord, setUpdateRecord ] = useState({});
    const [ searchInput, setSearchInput ] = useState('');
    const [ searchList, setSearchList] = useState([]);


    const [ updateType, setUpdateType ] = useState('');
    const [ recordId, setRecordId ] = useState('');
    const [ businessName, setBusinessName ] = useState('');
    const [ text, setText ] = useState('');

    const [ resultsList, setResultsList ] = useState([]);

    useEffect(() => {
        if(updateType !== ''){
            if(recordId !== '' || businessName !== '') getUpdateResultsList();
        }
    },[updateType,recordId,businessName]);

    const getUpdateResultsList = () => {
        const filterObject = {
            recordId: recordId,
            businessName: businessName,
            type: updateType
        };
        newUpdateRequestService.getUpdateResultsList(contextObject.apiToken, filterObject).then(res => setResultsList(res.data.resultsList)).catch(err => {
            console.error("Error fetching update results:", err);
        });
    };

    const createUpdateRequest = () => {
        const newUpdateRequest = {
            updateType: updateType,
            recordId: recordId,
            businessName: businessName,
            text: text,
            submitter: contextObject.activeUser.id,
        };
        // Call the service to create the update request
        newUpdateRequestService.createUpdateRequest(contextObject.apiToken, newUpdateRequest).then(res => {
            refreshUpdateList();
            setAddingRecord(false);
            setUpdateType('');
            setRecordId('');
            setBusinessName('');
            setText('');
        }).catch(err => {
            console.error("Error creating update request:", err);
        });
    };

    const markUpdateInactive = (requestId) => {
        newUpdateRequestService.inactivateRecord(contextObject.apiToken, requestId).then(res =>  refreshUpdateList());
    };

    const markUpdateActive = (requestId) => {
        newUpdateRequestService.activateRecord(contextObject.apiToken, requestId).then(res =>  refreshUpdateList());
    };

    const resetList = () => {
        setSearchInput('');
        setOrderBy('date');
        setActiveSort(true);
        refreshUpdateList();
        setSortDirection('ASC');
    };

    const selectSearchItem = (businessName) => {
        const filterObject = {
            searchInput:businessName,
        };
        newUpdateRequestService.getUpdateList(contextObject.apiToken, filterObject).then(res => setUpdateList(res.data.updateList));
    };

    const refreshSearchList = async () => {
        if(searchInput){
            const searchObject = {
                searchInput: searchInput,
            };
            newUpdateRequestService.getSearchList(contextObject.apiToken, searchObject).then(res => setSearchList(res.data.searchList));
        }
    };

    useEffect(() => {
        refreshSearchList();
    },[searchInput]);

    const flipSortOrder = () => {
        if(sortDirection === 'ASC') setSortDirection('DESC');
        else setSortDirection('ASC');
    };

    const handleOrderClick = (newOrderBy) => {
        if(newOrderBy === orderBy) flipSortOrder();
        else setOrderBy(newOrderBy)
    };

    const toggleFlag = (id) => {
        newUpdateRequestService.toggleUpdateFlag(contextObject.apiToken, id).then(res => refreshUpdateList());
    };

    const refreshUpdateList = () => {
        const filterObject = {
            active: activeSort,
            sortDirection: sortDirection,
            orderBy:orderBy,
            searchInput:searchInput,
        };
        newUpdateRequestService.getUpdateList(contextObject.apiToken, filterObject).then(res => setUpdateList(res.data));
    };

    useEffect(() => {
        refreshUpdateList();
    },[sortDirection, orderBy, activeSort]);

    const updateHeaderObject = {
        setSearchInput:setSearchInput,
        sortDirection:sortDirection,
        flipSortOrder:flipSortOrder,
        screenWidth:contextObject.screenWidth,
        handleOrderClick:handleOrderClick,
        orderBy: orderBy,
        searchList:searchList,
        selectSearchItem:selectSearchItem,
        resetList:resetList,
        activeSort:activeSort,
        setActiveSort:setActiveSort,
        setAddingRecord:setAddingRecord,
    };

    const updateRequestObject = {
        updateList:updateList,
        toggleFlag:toggleFlag,
        screenWidth: contextObject.screenWidth,
        markUpdateInactive:markUpdateInactive,
        markUpdateActive:markUpdateActive,
    };

    const newUpdateRequestObject = {
        setAddingRecord: setAddingRecord,
        updateType:updateType,
        setUpdateType:setUpdateType,
        recordId:recordId,
        setRecordId:setRecordId,
        businessName:businessName,
        setBusinessName:setBusinessName,
        text:text,
        setText:setText,
        createUpdateRequest:createUpdateRequest,
        resultsList:resultsList,
    };

    return(
        <div className='Update-Request-Window'>
            <UpdateRequestHeader updateHeaderObject={updateHeaderObject}/>
            <UpdateRequestDisplay updateRequestObject={updateRequestObject}/>      
            { addingRecord &&
                <NewUpdateRequestRecord newUpdateRequestObject={newUpdateRequestObject}/>
            }
        </div>
    )
};

export default UpdateRequests;